import { isValidTld } from "./validTlds.js";
/**
 * Simple email validation function, same stringency as Crystallize
 * - basic RFC-style local@domain checks
 * - validates TLD against IANA official list
 */
export const isValidEmail = (email) => {
    const parts = email.split("@");
    if (parts.length !== 2) {
        return "E-postadressen må inneholde én '@'.";
    }
    const [local, domain] = parts;
    if (!local || !domain) {
        return "Oppgitt e-postadresse er ikke gyldig.";
    }
    // Reject spaces in local or domain part
    if (local.includes(" ") || domain.includes(" ")) {
        return "E-postadressen kan ikke inneholde mellomrom.";
    }
    if (local.length > 64) {
        return "Første delen av e-postadressen har for mange tegn.";
    }
    if (local.startsWith(".") || local.endsWith(".") || local.includes("..")) {
        return "Første delen av e-postadressen kan ikke starte/slutte med punktum eller ha to punktum etter hverandre.";
    }
    const atomRegex = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+$/;
    const atoms = local.split(".");
    if (atoms.some((a) => a.length === 0 || !atomRegex.test(a))) {
        return "Det er et ugyldig tegn før @.";
    }
    if (domain.includes("_") ||
        domain.startsWith(".") ||
        domain.endsWith(".") ||
        domain.includes("..")) {
        return "Det er feil med delen etter alfakrøllen (@).";
    }
    const domainLabels = domain.split(".");
    if (domainLabels.length < 2 ||
        domainLabels.some((label) => label.length < 1 ||
            label.length > 63 ||
            label.startsWith("-") ||
            label.endsWith("-"))) {
        return "Andre del av e-postadressen er ugyldig eller inneholder ugyldige deler.";
    }
    const tld = domainLabels[domainLabels.length - 1];
    if (!isValidTld(tld)) {
        return "E-postadressen må slutte med for eksempel .no eller .com.";
    }
    return true;
};
